export default __webpack_public_path__ + "static/media/season_spring.faa94da3.webp";